export default "__VITE_ASSET__DU_vIMAE__"